// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tU","controlPlay":"tV","controlElement":"tW","lowerControlWrapper":"tX","lowerControlIconWrapper":"tY","lowerControlIcon":"tZ","show":"t0"};